var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg215(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reverse",
    transform: "translate(0.000000, -14.000000)",
    strokeWidth: 1.8,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.500000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "base",
    stroke: "#687577",
    fill: "#FFFFFF",
    d: "M20.6993892,25.1747818 C17.2888926,24.6489107 14.514508,22.1469037 13.3080293,20.8874904 C12.560047,21.942322 11.0771625,23.6987728 9.19705221,24.2318523 C7.27400573,24.7444956 5.22506661,24.465485 3.51025219,23.4574624 C2.11082927,22.6888967 1.09146423,21.3785277 0.692840525,19.8357481 C0.0532863553,17.0865954 -0.46923422,12.9039976 0.673564403,8.59370792 C0.682801529,8.56091714 0.694302879,8.52880304 0.707986049,8.4975957 C2.51684351,4.24909241 6.51285231,2.10304388 7.29560052,1.71653546 C12.4963669,-0.854809631 17.9979785,-0.521162931 22.0156729,2.60900606 C25.6819224,5.46834455 28.1052062,8.41487055 28.0119235,13.5043558 C27.9971498,14.76795 27.8997593,16.0292386 27.7203722,17.2801929 C27.6621426,17.6354651 27.6269594,17.9941136 27.615042,18.3539037 C27.615042,19.1090711 26.7297172,22.2395833 24.6723355,23.9977504 C23.7971625,24.7873097 22.6612541,25.2281408 21.4811048,25.236225 C21.2193331,25.2358964 20.95798,25.215354 20.6993892,25.1747818 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hookstyle",
    transform: "scale(-1, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hook",
    fill: "none",
    transform: "translate(-8.000000, -8.000000) ",
    d: "M3.58716581,4.86252597 C3.06706263,4.62380711 2.85229747,4.03585383 3.10747439,3.54929557 C3.36265132,3.06273731 3.99114002,2.86182379 4.5112432,3.10054265 C5.46056455,3.53626565 6.39450266,4.14450585 7.31484578,4.922185 C8.2443698,5.70762188 10.0438875,7.8539425 12.8028208,11.4459993 C13.1408693,11.8861293 13.0335172,12.4992928 12.5630432,12.8155382 C12.0925692,13.1317837 11.4371322,13.0313555 11.0990837,12.5912255 C8.44101017,9.13048544 6.68104531,7.03134029 5.90861111,6.37864246 C5.12699602,5.71818688 4.35258484,5.21384081 3.58716581,4.86252597 Z"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "extracted",
    x1: 4.5,
    y1: 5.5,
    x2: 24.5,
    y2: 22.5,
    stroke: "none",
    strokeLinecap: "square"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg215);
export default __webpack_public_path__ + "static/media/2-15.245614beec9c180853a9628db570b7d9.svg";
export { ForwardRef as ReactComponent };